import { useNavigate, useParams } from 'react-router';
import { ScreenSkeleton } from '../../../../components/atoms/ScreenSkeleton';
import { LoadRollerScreen } from './LoadRollerScreen';
import { ReturnRollerScreen } from './ReturnRollerScreen';
import { SliderScreen } from './SliderScreen';
import { useRollerAssemblyHook } from '../../../../store/rollerAssembly/rollerAssemblyAtoms';
import { ErrorBanner } from '../../../../components/atoms/ErrorBanner';
import useInspectionCategoryType from '../../../../hooks/useInspectionCategoryType';
import { useInspectionCached } from '../../../../hooks/useInspectionCached';

export const RollerAssemblyScreen = () => {
  const {
    externalId,
    sideName,
    partCategory,
    partName,
    equipmentPartId,
    position,
  } = useParams();
  const navigate = useNavigate();

  const { inspection } = useInspectionCached(externalId);

  const undercarriageCategory = useInspectionCategoryType({
    inspection,
  });

  const { error, equipmentPart } = useRollerAssemblyHook({
    inspectionCategoryTypeId: undercarriageCategory?.externalId,
    externalId,
    sideName,
    partCategory,
    partName,
    equipmentPartId,
    position,
  });

  if (!equipmentPart || !undercarriageCategory) {
    return <ScreenSkeleton fields={4} />;
  }

  if (error) {
    return <ErrorBanner message={error} />;
  }

  switch (partName) {
    case 'load-rollers':
      return (
        <LoadRollerScreen
          equipmentPart={equipmentPart}
          heading={partName!}
          subheading={`Position ${position}`}
        />
      );
    case 'return-rollers':
      return (
        <ReturnRollerScreen
          equipmentPart={equipmentPart}
          heading={partName!}
          subheading={`Position ${position}`}
        />
      );
    case 'sliders':
      return (
        <SliderScreen
          equipmentPart={equipmentPart}
          heading={partName!}
          subheading={`Position ${position}`}
        />
      );
    default:
      return <ScreenSkeleton fields={4} />;
  }
};
